import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import "../../App.css";
import HeaderBack from "../../components/Header/HeaderBack";
import DiceLoading from "../../components/DiceLoading";
import GetOneProfile from "../../components/GetProfile/GetOneProfile.js";
import GetOneProfileExtra from "../../components/GetProfile/GetOneProfileExtra.js";
import { getFamilyCon } from "../../handlers/dictionaryHandler.js";
import Cookies from "js-cookie";

const HelperHome = () => {
  let history = useHistory();

  const [helpersCandidates, setHelpersCandidates] = useState([]);
  const [helperFullName, setHelperFullName] = useState("");
  const [openProfileIds, setOpenProfileIds] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isInviteBoxOpen, setIsInviteBoxOpen] = useState(false);
  const [copySuccess, setCopySuccess] = useState("");
  const [isErrorMessageDisplayed, setIsErrorMessageDisplayed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  const alertUser = (message) => {
    setIsErrorMessageDisplayed(true);
    setErrorMessage(message);
  };

  const handleLogout = () => {
    Cookies.remove("userId");
    Cookies.remove("userType");
    Cookies.remove("helperCellular");

    history.push("/");
  };

  const chngPwdClicked = () => {
    history.push("/changepassword");
  };

  const helperCellular = Cookies.get("helperCellular") || "";
  const signupLink = `https://double2love.com/signup?refHelper=${helperCellular}`;

  const whatsappText = `היי 😊
רוצה להצטרף ל-Doube2Love?
זה הקישור להרשמה:
${signupLink}

אפשר להירשם ולמצוא התאמות בצורה נעימה ללא דפדוף וחשיפה `;

  const openWhatsAppShare = () => {
    window.open(
      `https://wa.me/?text=${encodeURIComponent(whatsappText)}`,
      "_blank",
    );
  };

  const copyInviteLink = async () => {
    try {
      await navigator.clipboard.writeText(signupLink);
      setCopySuccess("הקישור הועתק בהצלחה ✅");
      setTimeout(() => setCopySuccess(""), 2500);
    } catch (error) {
      setCopySuccess("לא הצלחנו להעתיק, אפשר להעתיק ידנית");
      setTimeout(() => setCopySuccess(""), 2500);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_LOCALHOST_ADDRESS + "/PhelperHome",
          config,
        );

        setHelperFullName(response.data.helper?.helperFullName || "");
        setHelpersCandidates(response.data.candidates || []);
        setIsDataLoaded(true);
      } catch (error) {
        setIsDataLoaded(true);
        alertUser("יש שגיאה בשרת או שאבד החיבור לאינטרנט, אנא נסה/י שנית");
      }
    };

    loadData();
  }, []);

  return (
    <form className="supermatchmaker-form">
      {isDataLoaded === true ? (
        <>
          <HeaderBack />
          <br />
          <div className="signup-body">
            <br />
            <h5 className="vipDescription">
              {helperFullName !== ""
                ? `שלום ${helperFullName}, טוב שבאת :)`
                : "טוב שבאת :)"}
            </h5>
            <h5 className="vipDescription">אזור הדאבליסטים המלווים</h5>
            <h5 className="subTitle">
              עוזרים לקרובים לכם למצוא את ההתאמה שלהם ❤️ (לאחר אישור גישה)
            </h5>

            <br />

            {helpersCandidates.length > 0 ? (
              helpersCandidates.map((candidate, index) => (
                <div className="pause-card" key={index}>
                  <div className="pause-title">{candidate.fullName}</div>

                  <div className="messegeMatch">
                    הקשר שלכם: {getFamilyCon(candidate.connection)}
                  </div>

                  <div className="messegeMatch">
                    סטטוס:{" "}
                    {candidate.allowSee == 1
                      ? "אישר/ה גישה ✅"
                      : "ממתין/ה לאישור"}
                  </div>

                  {candidate.allowSee == 1 ? (
                    <>
                      <div
                        className="faceline"
                        style={{ gap: "14px", alignItems: "flex-end" }}
                      >
                        <div style={{ flex: 1, paddingLeft: "4px" }}>
                          <div
                            className="action-btn helper-action-btn"
                            style={{ width: "100%" }}
                            onClick={() => {
                              setOpenProfileIds((prev) =>
                                prev.includes(candidate.idCandidate)
                                  ? prev.filter(
                                      (id) => id !== candidate.idCandidate,
                                    )
                                  : [...prev, candidate.idCandidate],
                              );
                            }}
                          >
                            {openProfileIds.includes(candidate.idCandidate)
                              ? "סגירת פרופיל"
                              : "צפייה בפרופיל"}
                          </div>
                        </div>

                        <div
                          style={{
                            flex: 1,
                            paddingRight: "4px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          {candidate.hasNewMatchThisWeek == 1 && (
                            <div
                              style={{
                                fontSize: "0.76rem",
                                color: "var(--btn-color)",
                                fontWeight: "600",
                                marginBottom: "4px",
                                lineHeight: "1",
                                minHeight: "14px",
                              }}
                            >
                              התאמה חדשה!
                            </div>
                          )}

                          <div style={{ position: "relative", width: "100%" }}>
                            <Link
                              to={{
                                pathname: "/helperMatches",
                                state: {
                                  candidateId: candidate.idCandidate,
                                  candidateName: candidate.fullName,
                                },
                              }}
                              className="action-btn helper-link-reset helper-action-btn"
                              style={{ width: "100%" }}
                            >
                              צפייה בהתאמות
                            </Link>

                            {candidate.hasNewMatchThisWeek == 1 && (
                              <span
                                style={{
                                  position: "absolute",
                                  top: "-4px",
                                  left: "-4px",
                                  width: "8px",
                                  height: "8px",
                                  borderRadius: "50%",
                                  background: "var(--btn-color)",
                                  boxShadow: "0 0 0 3px var(--dot-color)",
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          fontSize: "0.9rem",
                          color: "#777",
                          marginTop: "10px",
                          textAlign: "center",
                        }}
                      >
                        רוצים לעזור יותר? עברו על הפרופיל והציעו שיפורים
                      </div>
                      {openProfileIds.includes(candidate.idCandidate) && (
                        <div style={{ marginTop: "16px" }}>
                          <GetOneProfile otherId={candidate.idCandidate} />
                          <GetOneProfileExtra
                            otherId={candidate.idCandidate}
                            showManagerOnly={false}
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      style={{
                        fontSize: "0.9rem",
                        color: "#777",
                        marginTop: "8px",
                      }}
                    >
                      מחכה לאישור גישה מהמועמד/ת {candidate.fullName}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="pause-card">
                <div className="pause-title">עדיין אין כאן מועמדים</div>
                <div className="messegeMatch">
                  קרובים יכולים להירשם דרכך ולקבל את העזרה שלך בתהליך
                </div>
              </div>
            )}

            {isErrorMessageDisplayed && (
              <div className="error-message">
                <h5>{errorMessage}</h5>
              </div>
            )}

            <br />

            <div style={{ marginTop: "18px", textAlign: "center" }}>
              <div
                className="action-btn helper-action-btn"
                style={{
                  display: "inline-block",
                  minWidth: "260px",
                  fontWeight: "600",
                }}
                onClick={() => setIsInviteBoxOpen((prev) => !prev)}
              >
                אני רוצה לרשום קרובים נוספים ולעזור להם למצוא התאמה!
              </div>
            </div>

            {isInviteBoxOpen && (
              <div
                className="pause-card"
                style={{
                  marginTop: "16px",
                  textAlign: "center",
                  padding: "18px",
                }}
              >
                <div className="pause-title" style={{ fontSize: "1.1rem" }}>
                  שליחת קישור הרשמה
                </div>

                <div
                  style={{
                    fontSize: "0.95rem",
                    color: "#666",
                    marginTop: "8px",
                    marginBottom: "14px",
                  }}
                >
                  שלחו לקרוב/ה שלכם קישור להרשמה לדאבל 💙
                </div>

                <div
                  style={{
                    background: "#f8f8f8",
                    borderRadius: "12px",
                    padding: "10px 14px",
                    wordBreak: "break-all",
                    fontSize: "0.9rem",
                    color: "#444",
                    marginBottom: "14px",
                  }}
                >
                  {signupLink}
                </div>

                <div
                  className="faceline"
                  style={{ gap: "12px", justifyContent: "center" }}
                >
                  <div
                    className="action-btn helper-action-btn"
                    onClick={copyInviteLink}
                  >
                    העתקת קישור
                  </div>

                  <div
                    className="action-btn helper-action-btn"
                    onClick={openWhatsAppShare}
                  >
                    שליחה ב־WhatsApp
                  </div>

                  <a
                    href={signupLink}
                    target="_blank"
                    rel="noreferrer"
                    className="action-btn helper-link-reset helper-action-btn"
                  >
                    פתיחת דף ההרשמה
                  </a>
                </div>

                {copySuccess !== "" && (
                  <div
                    style={{
                      marginTop: "12px",
                      color: "#666",
                      fontSize: "0.9rem",
                    }}
                  >
                    {copySuccess}
                  </div>
                )}
              </div>
            )}

            <div
              className="faceline"
              style={{
                gap: "10px",
                justifyContent: "center",
                marginTop: "12px",
                alignItems: "center",
              }}
            >
              {Cookies.get("userType") === "3" && (
                <>
                  <div
                    onClick={() => history.push("/questionnaires")}
                    className="newGentleBack"
                    style={{ fontWeight: "600" }}
                  >
                    לאזור האישי
                  </div>

                  <span style={{ opacity: 0.3 }}>|</span>
                </>
              )}

              <div onClick={chngPwdClicked} className="newGentleBack">
                שינוי סיסמה
              </div>

              <span style={{ opacity: 0.3 }}>|</span>

              <div
                onClick={handleLogout}
                className="newGentleBack"
                style={{ opacity: 0.7 }}
              >
                יציאה
              </div>
            </div>
            {/* 
            <Link to="/questionnaires" style={{ textDecoration: "none" }}>
              <div className="button whiteBackNBorder" id="backBtn">
                <b>→</b>
                חזרה
              </div>
            </Link> */}

            <br />
          </div>
        </>
      ) : (
        <DiceLoading />
      )}
    </form>
  );
};

export default HelperHome;
